import { render } from "./TSComponentCompositionApi.vue?vue&type=template&id=482fb127"
import script from "./TSComponentCompositionApi.vue?vue&type=script&lang=ts"
export * from "./TSComponentCompositionApi.vue?vue&type=script&lang=ts"
script.render = render

export default script